import type { IconTypes } from '@common/components/icon';

import { CustomUserPropertyType, ECustomUserPropertyType } from '../types';

export function getCustomUserPropertyTypeIcon(
  type: CustomUserPropertyType | undefined
): IconTypes {
  const icons: Record<CustomUserPropertyType, IconTypes> = {
    [ECustomUserPropertyType.BOOLEAN]: 'check_box__filled',
    [ECustomUserPropertyType.DROPDOWN]: 'chevron_sort_vertical',
    [ECustomUserPropertyType.OPEN_TEXT]: 'list_long',
  };

  return type ? (icons[type] ?? 'list_text_wrap') : 'list_text_wrap';
}
